module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-042afa78e5b96ca79115cc0c914c45a2.webp";